export default class custSerOffers {
  constructor() {
    //Registering Events
    this.bindEvents();
  }

  bindEvents = () => {
    //nesthub view
    // var nestHubPl = $(window).width();
    //
    // if (nestHubPl < 1200) {
    //
    // this.productListingNestHubView.removeClass("d-none");
    //   $(".productListingNestHubMaxView22").addClass("d-none");
    // } else if (nestHubPl > 1199) {
    //
    // this.productListingNestHubMaxView.removeClass("d-none");
    //       $(".productListingNestHubView22").addClass("d-none");
    //     }
  };

  order_list = () => {
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderList",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: this.showPreviousOrdersOnServicingPage,
      error: (result) => {},
    });
  };
}

